import { ToastOptions } from "react-toastify";
import { Languages } from "../../app/utils/common/constants";

export const ToastDefaultConfig = () : ToastOptions =>  {
    // Parse language from localStorage with proper error handling
    let currentLanguage = Languages.en; // default to English
    try {
        const authData = localStorage.getItem('persist:b8aksp-auth');
        if (authData) {
            const parsed = JSON.parse(authData);
            if (parsed.language) {
                // language is stored as a JSON string, parse it
                const langValue = typeof parsed.language === 'string' ? JSON.parse(parsed.language) : parsed.language;
                currentLanguage = langValue || Languages.en;
            }
        }
    } catch (error) {
        console.error('Error parsing language from localStorage:', error);
    }
    
    // Arabic (ar) = top-left (RTL), English (en) = top-right (LTR)
    const position = currentLanguage === Languages.ar ? "top-left" : "top-right";
    
    return {
        position,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    }
}